<template>
  <v-container v-if="valid && site_id !== undefined" fluid class="full-height ma-0 pa-1" style="border:0px solid green;">
    <v-row class="ma-2 pa-0" style="border:0px solid red;">
      <v-col class="ma-0 pa-0" cols="12">

        <PortfolioManagerSiteDetails :siteRef="site_ref"></PortfolioManagerSiteDetails>

      </v-col>
    </v-row>

    <v-row class="fill-height ma-1 pa-0" style="border:0px solid red;">
      <v-col class="ma-0 pa-0" cols="12">

        <PortfolioGraphContainer title="Heating">
           <template v-slot:monthly_graph>
              <BarChartFromCsv :v-if="showWait"
                :xMin="startOfYear"
                :url="site_id + '/heating_12_months.csv'"
                title="Last 12 Months"
                aggregate="avg"
                mainPlotTitle="Monthly values"
                timeUnit="month"
                ylabel="kWh"
                :chartAttributes="[default_12_month_rollog_attributes, default_bar_plot_attributes('Heating')]"
              ></BarChartFromCsv>
           </template>

           <template v-slot:daily_graph>
              <BarChartFromCsv
                :xMin="startOfMonth"
                :url="site_id + '/heating_last_month.csv'"
                title="Last 30 Days"
                mainPlotTitle="Daily values"
                timeUnit="day"
                ylabel="kWh"
                :chartAttributes="[default_last_month_rolling_attributes, default_bar_plot_attributes('Heating')]"
              ></BarChartFromCsv>
           </template>

        </PortfolioGraphContainer>

      </v-col>
    </v-row>

    <v-row class="fill-height ma-1 pa-0" style="border:0px solid red;">
      <v-col class="ma-0 pa-0" cols="12">

       <PortfolioGraphContainer title="Comfort">

          <template v-slot:monthly_graph>
              <BarChartFromCsv :v-if="showWait"
                :xMin="startOfYear"
                :url="site_id + '/comfort_12_months.csv'"
                title="Last 12 Months"
                aggregate="avg"
                mainPlotTitle="Monthly values"
                timeUnit="month"
                ylabel="℃"
                :chartAttributes="[default_12_month_rollog_attributes, default_bar_plot_attributes('Comfort')]"
              ></BarChartFromCsv>
           </template>

           <template v-slot:daily_graph>
              <BarChartFromCsv
                :xMin="startOfMonth"
                :url="site_id + '/comfort_last_month.csv'"
                title="Last 30 Days"
                mainPlotTitle="Daily values"
                timeUnit="day"
                ylabel="℃"
                :chartAttributes="[default_last_month_rolling_attributes, default_bar_plot_attributes('Comfort')]"
              ></BarChartFromCsv>
           </template>

        </PortfolioGraphContainer>

      </v-col>
    </v-row>

    <v-row class="fill-height ma-1 pa-0" style="border:0px solid red;">
      <v-col class="ma-0 pa-0" cols="12">

      <PortfolioGraphContainer title="Hotwater">

            <template v-slot:monthly_graph>
              <BarChartFromCsv :v-if="showWait"
                :xMin="startOfYear"
                :url="site_id + '/hotwater_12_months.csv'"
                title="Last 12 Months"
                aggregate="avg"
                mainPlotTitle="Monthly values"
                timeUnit="month"
                ylabel="℃"
                :chartAttributes="[default_12_month_rollog_attributes, default_bar_plot_attributes('Hotwater')]"
              ></BarChartFromCsv>
           </template>

           <template v-slot:daily_graph>
              <BarChartFromCsv
                :xMin="startOfMonth"
                :url="site_id + '/hotwater_last_month.csv'"
                title="Last 30 Days"
                mainPlotTitle="Daily values"
                timeUnit="day"
                ylabel="℃"
                :chartAttributes="[default_last_month_rolling_attributes, default_bar_plot_attributes('Hotwater')]"
              ></BarChartFromCsv>
           </template>

        </PortfolioGraphContainer>

      </v-col>
    </v-row>

    <v-row class="fill-height ma-1 pa-0" style="border:0px solid red;">
      <v-col class="ma-0 pa-0" cols="12">

        <PortfolioGraphContainer title="Appliances">

          <template v-slot:monthly_graph>
              <BarChartFromCsv :v-if="showWait"
                :xMin="startOfYear"
                :url="site_id + '/appliances_12_months.csv'"
                title="Last 12 Months"
                aggregate="avg"
                mainPlotTitle="Monthly values"
                timeUnit="month"
                ylabel="kWh"
                :chartAttributes="[default_12_month_rollog_attributes, default_bar_plot_attributes('Appliances')]"
              ></BarChartFromCsv>
           </template>

           <template v-slot:daily_graph>
              <BarChartFromCsv
                :xMin="startOfMonth"
                :url="site_id + '/appliances_last_month.csv'"
                title="Last 30 Days"
                mainPlotTitle="Daily values"
                timeUnit="day"
                ylabel="kWh"
                :chartAttributes="[default_last_month_rolling_attributes, default_bar_plot_attributes('Appliances')]"
              ></BarChartFromCsv>
           </template>

        </PortfolioGraphContainer>

      </v-col>
    </v-row>

    <v-row class="fill-height ma-1 pa-0" style="border:0px solid red;">
      <v-col class="ma-0 pa-0" cols="12">
        <v-card>
          <v-card-title>Custom KPIs</v-card-title>
          <v-card-subtitle></v-card-subtitle>
          <v-card-text>
            <v-container
              fluid
              class="full-height ma-0 pa-1"
              style="height:100%;border:0px solid green;"
            ></v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>


  </v-container>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import BarChartFromCsv from './PortfolioCharts/BarChartFromCsv.vue';
import BarChartAverageOfRefsLast30DaysFromCsv from './PortfolioCharts/BarChartAverageOfRefsLast30DaysFromCsvOLD.vue';
import FaceRating from '@/components/FaceRating.vue';
import FullScreenLoad from '@/components/FullScreenLoad.vue';
import { IProfileSitePoints, IRefInfo, ICarnegoUser, ISiteGroup } from '@/main';
import { IChartAttributes } from './PortfolioCharts/ChartInterfaces';
import { dateRangeForLast12Month, dateRangeForLastMonth } from '@/common';
import PortfolioManagerSiteDetails from './PortfolioManagerSiteDetails.vue';
import PortfolioGraphContainer from './PortfolioGraphContainer.vue';
import { DateTime } from "luxon";

interface IKeyValue {
  name: string;
  value: string;
}

@Component({
  components: {
    FaceRating,
    PortfolioManagerSiteDetails,
    BarChartFromCsv,
    PortfolioGraphContainer,
  },
})
export default class PortfolioManagerDetails extends Vue {

  public showWait: boolean = true;
  public valid: boolean = false;
  // @Prop({ default: () => undefined }) public site_ref!: string | undefined;
  public site_ref: string | undefined = undefined;
  public site_id: string | undefined = undefined;

  public graphData: object[] = [];

  public default_12_month_rollog_attributes = {
                data_column_index: 2,
                title: "Rolling Yearly Avg",
                type: "line",
                fill: false,
                visible: true,
                backgroundColor: 'rgba(240, 155, 21, 1.0)',
                borderColor: 'rgba(240, 155, 21, 1.0)',
                };

  public default_last_month_rolling_attributes = {
                data_column_index: 1,
                title: "Previous 31 days Avg",
                type: "line",
                fill: false,
                visible: true,
                backgroundColor: 'rgba(240, 155, 21, 1.0)',
                borderColor: 'rgba(240, 155, 21, 1.0)',
                };

  @Prop({ default: dateRangeForLast12Month() }) readonly dateRangeForLast12Month!: string;
  @Prop({ default: dateRangeForLastMonth() }) readonly dateRangeForLastMonth!: string;

  public async created() {
    const self = this;
  }

  public async mounted() {
    const self = this;

    self.showWait = true;

    self.site_ref = self.$route.params.id;
    self.site_id = self.site_ref.substring(1);
    console.log("site_ref details:", self.site_ref);

    await self.$nextTick();

    const start = DateTime.now().toUTC().minus({days:31}).startOf('day'); // .toFormat("yyyy-MM-dd'T'HH:mm:ss");

    self.showWait = false;
    self.valid = true;

    return;
  }

  public async update() {
    console.log('update PortfolioDetails');
  }

  public default_bar_plot_attributes(title: string): object {
    return { data_column_index: 0,
             title: title,
             type: "bar",
             fill: true,
             backgroundColor: 'rgba(29,133,147, 1.0)',
             borderColor: 'rgba(29,133,147, 1.0)',
             visible: true,
           }
  }

  // private get site_id(): string | undefined {

  //   if(this.site_ref === undefined) {
  //     return undefined;
  //   }

  //   return this.site_ref.substring(1);
  // }

  public get startOfYear(): string {
    return DateTime.now()
      .toUTC()
      .minus({ months: 13 })
      .toFormat("yyyy-MM-dd'T'HH:mm:ss");
  }

  public get startOfMonth(): string {
    return DateTime.now()
      .toUTC()
      .minus({ months: 1 })
      .toFormat("yyyy-MM-dd'T'HH:mm:ss");
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>